export function createRedirectLink(nspkLink: string, bankUrl: string) {
    const { pathname, search } = new URL(nspkLink)

    const qrcId = pathname.replace('/', '')

    return bankUrl.replace('{QRC_ID}', qrcId).replace('{QUERY_STRING}', search)
}
